
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, PasswordResetViewModel, TylerUser, UserLookupViewModel } from "@tylertech/tyler-api-types";

/**
 * UserService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class UserService {
    private readonly $apiService = inject(ApiService);
    
    ChangePassword(model: PasswordResetViewModel): Promise<void> {
        return this.$apiService.sendAuth("IUserService/ChangePassword", model);
    }
    CreateUser(user: TylerUser): Promise<void> {
        return this.$apiService.sendAuth("IUserService/CreateUser", user);
    }
    DisableUser(userId: string): Promise<void> {
        return this.$apiService.sendAuth("IUserService/DisableUser", userId);
    }
    EmailPasswordResetLink(username: string): Promise<void> {
        return this.$apiService.sendUnauth("IUserService/EmailPasswordResetLink", username);
    }
    EnableUser(userId: string): Promise<void> {
        return this.$apiService.sendAuth("IUserService/EnableUser", userId);
    }
    Get(): Promise<UserLookupViewModel> {
        return this.$apiService.sendAuth("IUserService/Get");
    }
    GetAllViewModelUsers(filterString?: string): Promise<UserLookupViewModel[]> {
        return this.$apiService.sendAuth("IUserService/GetAllViewModelUsers", null, filterString);
    }
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<UserLookupViewModel[]>> {
        return this.$apiService.sendAuth("IUserService/Lookup", pCriteria);
    }
    ResetPassword(model: PasswordResetViewModel): Promise<void> {
        return this.$apiService.sendUnauth("IUserService/ResetPassword", model);
    }
}
